<template>
  <svg
    :width="width"
    version="1.1"
    viewBox="0 0 400 176.2"
    xmlns="http://www.w3.org/2000/svg">
    <defs>
      <clipPath id="clipPath18">
        <path d="m0 350h700v-350h-700z" />
      </clipPath>
    </defs>
    <g transform="matrix(1.3333 0 0 -1.3333 0 176.2)">
      <g transform="matrix(.73848 0 0 .75699 -108.47 -66.236)">
        <g clip-path="url(#clipPath18)">
          <g transform="translate(442.92 247.32)">
            <path
              d="m0 0v13.734l-48.719
              0.972h-19.619c-9.182
              0-17.373-3.211-24.091-8.152-6.718
              4.941-14.909 8.152-24.091
              8.152h-19.619l-48.719-0.972v-13.734l16.21-4.994
              v-134.85l-16.21-4.995v-14.983h48.719v143.06h19.619c4.496
              0
              8.491-3.747
              8.491-8.242v-60.005l31.223
              9.899-0.023
              50.106c0
              4.495
              3.995
              8.242
              8.491
              8.242h19.619v-143.06h48.719v14.983l-16.21
              4.995v134.85z"
              :fill="color" />
          </g>
          <g transform="translate(334.89 139.92)">
            <path
              d="m0 0v-52.419h31.2v62.046z"
              :fill="color" />
          </g>
          <g transform="translate(525 157.16)">
            <path
              d="m0
              0-17.378-9.136
              3.319
              19.351-14.06
              13.704
              19.43
              2.824
              8.689
              17.606
              8.689-17.606
              19.43-2.824-14.06-13.704
              3.319-19.351z"
              :fill="color" />
          </g>
          <g transform="translate(175 157.16)">
            <path
              d="m0
              0-17.378-9.136
              3.319
              19.351-14.06
              13.704 19.43
              2.824
              8.689
              17.606
              8.689-17.606
              19.43-2.824-14.06-13.704
              3.319-19.351z"
              :fill="color" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 50,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
  },
};
</script>

<style lang="css">
</style>
